'use strict';

module.exports = function(str) {
  return window.atob(str);
};



//////////////////
// WEBPACK FOOTER
// ./~/mapbox/lib/atob.js
// module id = 107
// module chunks = 0